import styled from '@emotion/styled';

export const MainBlock = styled.div`
  margin: 24px 24px 0 24px;

  max-height: 200px;
  overflow: auto;
`;
